import React from "react"
import CalculateButtonStyle from "./CalculateButtonStyle.module.css"
import translate, { keys } from "../../../../../translation/translator"

const CalculateButton = ({ handleShowResults, locale }) => {
  return (
    <div className={CalculateButtonStyle.holder}>
      <a
        href="#calorie-result"
        onClick={handleShowResults}
        className={CalculateButtonStyle.button}
      >
        {translate(keys.GET_RESULTS_BUTTON, locale)}
      </a>
    </div>
  )
}

export default CalculateButton
